export enum ModalOrigin {
    CONTRACT_LIST = "contract_list",
    CONTRACT_LOCAL_DEATILS = "contract_local_details",
}
